import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState } from 'react';
import { User } from '../types/user';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import { useQuery } from 'react-query';
import { api } from '../api';
import jwtDecode from 'jwt-decode';
import PageLoader from '../components/loader'
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'prime_renov_status', label: 'Status', alignRight: false },
  { id: 'subject', label: 'Requête', alignRight: false },
  { id: 'phoneNumber', label: 'Téléphone', alignRight: false },
  { id: 'city', label: 'Ville', alignRight: false },
  { id: 'phoneValidated', label: 'Téléphone Vérifié', alignRight: false },
  { id: 'emailValidated', label: 'Email Vérifié', alignRight: false },
  { id: 'token', label: 'Token Utilisateur', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a: any, b: any, orderBy: any) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === 'desc'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array: any, comparator: any, query: any) {
  const stabilizedThis = array.map((el: any, index: number) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el: any) => el[0]);
}

export default function UserPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [currentToken, setCurrentToken] = useState('');

  const token: any = jwtDecode(localStorage.getItem('token'));

  const navigate = useNavigate();


  const { data, isLoading } = useQuery(['users'], () => api.getAllUser(token.token), {
    cacheTime: 1200,
    staleTime: 1200,
  })

  const clients = data?.clients || []

  const handleOpenMenu = (event: any) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {
    if (event.target.checked) {
      const newSelecteds: any = clients.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const myArray: (string | number | never | object | any)[] = selected
  const handleClick = (event: any, name: string) => {
    const selectedIndex = myArray.indexOf(name);
    let newSelected: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(myArray, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(myArray.slice(1));
    } else if (selectedIndex === myArray.length - 1) {
      newSelected = newSelected.concat(myArray.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(myArray.slice(0, selectedIndex), myArray.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: any) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - clients.length) : 0;

  const filteredUsers = applySortFilter(clients, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title>Utilisateur</title>
      </Helmet>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          Clients De MyPrimeRénov
        </Typography>
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          Créér un utilisateur
        </Button>
      </Stack>

      {isLoading ? <PageLoader /> : <>
        <Card>
          <UserListToolbar numSelected={myArray.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar sx={{}}>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={clients.length}
                  numSelected={myArray.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row: User) => {

                    const name: string = row.name;
                    const token: string = row.token;
                    const phoneValidated: boolean = row.phoneValidated;
                    const emailValidated: boolean = row.emailValidated;
                    const status: boolean = row.prime_status;
                    const phoneNumber: string = row.phoneNumber;
                    const subject: string = row.subject;
                    const city: string = row.city;

                    const selectedUser = myArray.indexOf(name) !== -1;

                    return (
                      <TableRow key={token} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{status}</TableCell>

                        <TableCell align="left">{subject}</TableCell>

                        <TableCell align="left">{phoneNumber}</TableCell>

                        <TableCell align="left">{city}</TableCell>

                        <TableCell align="left"><Label color={phoneValidated ? 'success' : 'error'}>{phoneValidated ? 'oui' : 'non'}</Label></TableCell>

                        <TableCell align="left">
                          <Label color={emailValidated ? 'success' : 'error'}>{emailValidated ? 'oui' : 'non'}</Label>
                        </TableCell>

                        <TableCell align="left">
                          <Label>{token}</Label>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={e => {
                            setCurrentToken(token)
                            handleOpenMenu(e)
                          }}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}

                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Aucun résultat
                          </Typography>

                          <Typography variant="body2">
                            Aucun résultat pour la requête: &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Essayer avec le nom ou le prénom au complet.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={clients.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </>}

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => {
          handleCloseMenu();
          navigate(`/dashboard/user/profile/${currentToken}`)
          setTimeout(() => {
            setCurrentToken('')
          }, 2000)
        }}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Profile
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Supprimer
        </MenuItem>
      </Popover>
    </>
  );
}
